import React, { Component } from "react";
// import 'brace';
import AceEditor from 'react-ace';
import { withSize, SizeMe } from 'react-sizeme'
import cn from "classnames";
// import ScrollLock, { TouchScrollable } from 'react-scrolllock';

import 'ace-builds/src-noconflict/mode-php'
import 'ace-builds/src-noconflict/mode-javascript'
import 'ace-builds/src-noconflict/mode-jsx'
import 'ace-builds/src-noconflict/mode-css'
import 'ace-builds/src-noconflict/mode-json'
import 'ace-builds/src-noconflict/mode-mysql'
import 'ace-builds/src-noconflict/mode-html'
import 'ace-builds/src-noconflict/theme-chrome'


class WrappedAceEditor extends React.Component {
    static defaultProps = {
        alwaysAllowFullscren: false,
        maxLines: 20,
        minLines: 1,
        renderFullscreenToolbarElements: () => null
    };

    renderEditor = ({size}) => {
        let { isFullscreen, setFullscreen, value, maxLines, minLines, alwaysAllowFullscren, ...otherProps } = this.props;

        let lineCount = (value && value.split('\n').length) || 0,
            canBeFullscreen = alwaysAllowFullscren || lineCount > maxLines;

        let editorDimensionProps = isFullscreen ?
            {
                width: size.width+'px',
                height: size.height+'px'
            } :
            {
                width: '710px',
                maxLines, minLines
            };

        return (
            <div className={cn('editor-container',{ fullscreen: isFullscreen})}>

                {canBeFullscreen && <div className="editor-toolbar-container">
                    <div className="editor-toolbar-left-spacer">
                    </div>
                    <ul className="editor-toolbar">
                        <li>{isFullscreen ?
                            <button
                                type="button"
                                className="btn btn-outline-primary"
                                onClick={() => setFullscreen(false)}>
                                Close Fullscreen
                            </button> :
                            <button
                                type="button"
                                className="btn btn-outline-primary"
                                onClick={() => setFullscreen(true)}
                            >Open Fullscreen
                            </button>}
                        </li>
                        {isFullscreen && this.props.renderFullscreenToolbarElements()}
                    </ul>
                </div>}

                <AceEditor
                    mode="javascript"
                    theme="chrome"
                    value={value}
                    editorProps={{$blockScrolling: true}}
                    {...editorDimensionProps}
                    {...otherProps}
                />
            </div>
        );
    }



    render() {
        const renderInner = () => <SizeMe render={this.renderEditor} monitorHeight refreshRate={50}/>;

        // return (
        //     <div className="editor-container-container">
        //         {this.props.isFullscreen ? <ScrollLock>
        //             {renderInner()}
        //         </ScrollLock> : renderInner()}
        //     </div>
        // )

        return (
            <div className="editor-container-container">
                {renderInner()}
            </div>
        )
    }
};

export default WrappedAceEditor;